import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import AccordionToggle from '../../components/AccordionToggle';
// import { colors } from '../../styles';

const styles = css`
.AccordionToggle_content {
  background-color: #000000;
  text-align: center;
  line-height: 31px;
  margin-bottom: 35px;
  margin: 0;
  color: #FFFFFF;
  padding: 50px 0;
  @media (min-width: 992px) {
    padding: 100px 0;
  }
}
  .SectionPlan_scrollRef {
    position: absolute;
    width: 100%;
    height: 1px;
    @media (min-width: 768px) {
      margin-top: -40px;
    }
    @media (min-width: 992px) {
      margin-top: -60px;
    }
  }
  .SectionPlan_head {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 1.083333em;
    }
  }
  .SectionPlan_head-noResults {
    @media (min-width: 768px) {
      margin-bottom: 0.625em;
    }
  }
  .SectionPlan_photos {
    margin-bottom: -10px;
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-left: -7.5px;
      margin-right: -7.5px;
      margin-bottom: -20px;
    }
    @media (min-width: 992px) {
      margin-left: -15px;
      margin-right: -15px;
      margin-bottom: -30px;
    }
  }
  .SectionPlan_photoWrapper {
    width: 100%;
    margin-bottom: 10px;
    @media (min-width: 768px) {
      display: flex;
      align-items: center;
      width: 50%;
      padding: 0 7.5px;
      margin-bottom: 20px;
    }
    @media (min-width: 992px) {
      padding: 0 15px;
      margin-bottom: 30px;
    }
  }
  .SectionPlan_photo {
    display: block;
    width: 100%;
    padding: 15px;
    border: 1px solid #E2E2E2;
    @media (min-width: 768px) {
      padding: 25px;
    }
  }
  .SectionPlan_noResults {
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.022353em;
    line-height: 1.941176;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    @media (min-width: 992px) {
      font-size: 19px;
    }
  }
`;


function SectionPlan({ className, photos }) {
  return (
    <div className={cx(styles, className)}>
      <div className="SectionPlan_scrollRef" id="floor-plan" />
      <AccordionToggle
        openOnId="floor-plan"
        button="Floor Plan"
      >
        <h3
          className={[
            'HomeDetail_sectionHead',
            'SectionPlan_head',
            'GoldText',
            !photos.length ? 'SectionPlan_head-noResults' : '',
          ].join(' ').trim()}
        >
          Floor Plan
        </h3>
        {
          photos.length > 0 &&
          <div className="SectionPlan_photos">
            {
              photos.map(photo => {
                const photoUrl = get(photo, 'contentUrl');
                return (
                  <div className="SectionPlan_photoWrapper mx-auto" key={photoUrl}>
                    <Image
                      className="SectionPlan_photo"
                      src={photoUrl}
                      alt={get(photo, 'name', '')}
                      width={600}
                      height={600}
                    />
                  </div>
                );
              })
            }
          </div>
        }
        {
          !photos.length &&
          <p className="SectionPlan_noResults">
            {'No floor plan available for this property at this time.'}
          </p>
        }
      </AccordionToggle>
    </div>
  );
}

SectionPlan.propTypes = {
  className: PropTypes.string,
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

SectionPlan.defaultProps = {
  className: undefined,
};

export default SectionPlan;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/SectionPlan.js